"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _DateRangePicker = require("./DateRangePicker");
Object.keys(_DateRangePicker).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DateRangePicker[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DateRangePicker[key];
    }
  });
});